/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import { GoArrowRight } from "react-icons/go";
import { FiPlus } from "react-icons/fi";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MyContext } from '../Context/MyProvider';
import BookingDetails from './DocAppointment/BookingDetails';
import AddPatient from './DocAppointment/AddPatient';
import { FaStar } from "react-icons/fa";
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import OneSignal from 'react-onesignal';
import { useTranslation } from 'react-i18next';
import LocationImg from "../assets/Image/permission.png";
import { showToast } from '../showTost';
import Loading from './Loading';
import NotificationImg from "../assets/Image/Notification.png";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from './ImageLoad';
import Banner from './Banner';
import { motion } from 'framer-motion';

const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#4038FF] p-[3px] rounded-[50px] absolute z-10 right-[40px] -top-[34px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronLeft color="#fff" size={22} />
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#4038FF] p-[3px] rounded-[50px] absolute z-10 right-[0px] -top-[34px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronRight color="#fff" size={22} />
    </div>
);


const Dashboard = () => {
    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl, patientStatus, isLogin, setAgoraAppId, setMapKey, setIsLoginShow, paymentStatus, setPaymentStatus } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [sliderImg, setSliderImg] = useState([]);
    const [bookingData, setBookingData] = useState();
    const [isBooking, setIsBooking] = useState(false);
    const [familyMemberList, setFamilyMemberList] = useState([]);
    const [isPatient, setIsPatient] = useState(false);
    const [relationshipData, setRelationshipData] = useState([]);
    const [booldData, setBooldData] = useState([]);
    const [patientData, setPatientData] = useState();
    const [favoritList, setFavoriteList] = useState([]);
    const [dynamicList, setDynamicList] = useState([]);
    const [deviceCheck, setDeviceCheck] = useState(false);
    const [locationError, setLocationError] = useState(false);
    const [notificationerror, setNotificationError] = useState(false);

    const CategoryList = [
        { label: 'Talk to Doctor', href: '/video-consultation-doctors', active: false, gradient: 'from-[#00BCD4] to-[#00E5FF]', color: 'text-[#00BCD4]', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="w-7 h-7 transition-all group-hover:scale-110" aria-hidden="true"><path d="M11 2v2"></path><path d="M5 2v2"></path><path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"></path><path d="M8 15a6 6 0 0 0 12 0v-3"></path><circle cx="20" cy="10" r="2"></circle></svg> },
        { label: 'Appointment Book', href: '/services', active: false, gradient: 'from-blue-400 to-indigo-500', color: 'text-blue-600', icon: <svg className="w-7 h-7 transition-all group-hover:scale-110" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75H16.75V3C16.75 2.586 16.414 2.25 16 2.25C15.586 2.25 15.25 2.586 15.25 3V3.75H8.75V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V3.75H6C3.582 3.75 2.25 5.082 2.25 7.5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V7.5C21.75 5.082 20.418 3.75 18 3.75ZM6 5.25H7.25V6C7.25 6.414 7.586 6.75 8 6.75C8.414 6.75 8.75 6.414 8.75 6V5.25H15.25V6C15.25 6.414 15.586 6.75 16 6.75C16.414 6.75 16.75 6.414 16.75 6V5.25H18C19.577 5.25 20.25 5.923 20.25 7.5V8.25H3.75V7.5C3.75 5.923 4.423 5.25 6 5.25ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V9.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM9.02002 13C9.02002 13.552 8.57302 14 8.02002 14C7.46802 14 7.01489 13.552 7.01489 13C7.01489 12.448 7.45801 12 8.01001 12H8.02002C8.57202 12 9.02002 12.448 9.02002 13ZM13.02 13C13.02 13.552 12.573 14 12.02 14C11.468 14 11.0149 13.552 11.0149 13C11.0149 12.448 11.458 12 12.01 12H12.02C12.572 12 13.02 12.448 13.02 13ZM17.02 13C17.02 13.552 16.573 14 16.02 14C15.468 14 15.0149 13.552 15.0149 13C15.0149 12.448 15.458 12 16.01 12H16.02C16.572 12 17.02 12.448 17.02 13ZM9.02002 17C9.02002 17.552 8.57302 18 8.02002 18C7.46802 18 7.01489 17.552 7.01489 17C7.01489 16.448 7.45801 16 8.01001 16H8.02002C8.57202 16 9.02002 16.448 9.02002 17ZM13.02 17C13.02 17.552 12.573 18 12.02 18C11.468 18 11.0149 17.552 11.0149 17C11.0149 16.448 11.458 16 12.01 16H12.02C12.572 16 13.02 16.448 13.02 17ZM17.02 17C17.02 17.552 16.573 18 16.02 18C15.468 18 15.0149 17.552 15.0149 17C15.0149 16.448 15.458 16 16.01 16H16.02C16.572 16 17.02 16.448 17.02 17Z" fill="currentColor" /></svg> },
        { label: 'Book Clinic Visit', href: '/clinic-visit-doctors', active: false, gradient: 'from-purple-400 to-pink-500', color: 'text-purple-600', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="w-7 h-7 transition-all group-hover:scale-110" aria-hidden="true"><path d="M11 2v2"></path><path d="M5 2v2"></path><path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"></path><path d="M8 15a6 6 0 0 0 12 0v-3"></path><circle cx="20" cy="10" r="2"></circle></svg> },
        { label: 'Medicine', href: '/shop', active: false, gradient: 'from-emerald-400 to-teal-500', color: 'text-emerald-600', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 transition-all group-hover:scale-110" aria-hidden="true"><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path><path d="m8.5 8.5 7 7"></path></svg> },
        { label: 'Lab Test & Packages', href: '/lab-details', active: false, gradient: 'from-orange-400 to-red-500', color: 'text-orange-600', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 transition-all group-hover:scale-110" aria-hidden="true"><path d="M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3"></path><path d="m16 2 6 6"></path><path d="M12 16H4"></path></svg> }
    ]

    const navigate = useNavigate();
    const initialized = useRef(false);
    const HomeRef = useRef(false);

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const Patientsetting = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 7,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            { breakpoint: 995, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 380, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        ],
    };

    const boxsetting = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1030, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    const labsetting = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const lat = String(position.coords.latitude);
                    const long = String(position.coords.longitude);
                    fetchHomeData(lat, long);
                    HandleGetmember();
                    handleNotificationModel();
                },
                error => {
                    if (!secureLocalStorage.getItem("location")) {
                        setLocationError(true);
                    } else {
                        handleNotificationModel();
                        fetchHomeData(21.215814, 72.828308);
                    }
                }
            );
        }

    }, [isLogin]);

    const handleNotificationModel = () => {
        if ("Notification" in window) {
            Notification.requestPermission().then((res) => {
                if (res === "denied") {
                    if (!secureLocalStorage.getItem("notification")) {
                        setNotificationError(true);
                    }
                }
            })
        }
    }

    const fetchHomeData = (lat, long) => {
        if (HomeRef.current) return;
        HomeRef.current = true;

        setLoading(true);
        const Userid = secureLocalStorage.getItem("Userid") || "0";

        axios.post(`${ApiBaseUrl}/customer/home`, { id: Userid, lat: lat, lon: long })
            .then((res) => {
                console.log("Home Data", res.data);
                const { banner_data, general_currency, ResponseCode, fav_doctor_list, dynamic_list, wallet } = res.data;
                if (ResponseCode === 200) {
                    setSliderImg(banner_data);
                    setFavoriteList(fav_doctor_list);
                    setDynamicList(dynamic_list);
                    secureLocalStorage.setItem("currency", general_currency.site_currency);
                    OneSignalHandle(general_currency.one_app_id_react);
                    setAgoraAppId(general_currency.agora_app_id);
                    setMapKey(general_currency.google_map_key);
                    secureLocalStorage.setItem("wallet", wallet);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Home Api", error);
            })

    }

    useEffect(() => {
        if (patientStatus) {
            HandleGetmember();
            setIsPatient(false);
        }
    }, [patientStatus])

    const HandleGetmember = () => {
        const Userid = secureLocalStorage.getItem("Userid");


        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/family_member_list`, { id: Userid })
                .then((res) => {
                    console.log("customer/family_member_list", res);
                    setFamilyMemberList(res.data.family_member);
                })
                .catch((error) => {
                    console.error(error);
                })

            axios.get(`${ApiBaseUrl}/customer/family_member_add_detail`)
                .then((res) => {
                    const { relationship_list, blood_group_list } = res.data;
                    setRelationshipData(relationship_list);
                    setBooldData(blood_group_list);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    useEffect(() => {
        const status = sessionStorage.getItem("Bookid");
        if (status) {
            HandleBookAppointGet(status);
        }
    }, []);

    const HandleBookAppointGet = (id) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/success_appo_detail`, { id: Userid, appointment_id: id })
                .then((res) => {
                    // console.log("success_appo_detail", res);
                    setIsBooking(true);
                    setBookingData(res.data);
                    sessionStorage.removeItem("Bookid");
                })
                .catch((error) => {
                    console.error("success_appo_detail", error);
                })
        }
    }

    const HandleGetPatientDetails = (id) => {
        axios.post(`${ApiBaseUrl}/customer/family_member_detail`, { fid: id })
            .then((res) => {
                // console.log(res);
                setPatientData(res.data.data);
                setIsPatient(true);
            })
            .catch((error) => {
                console.error(error);
            })
    }

    const HandleNavigateDoc = (title, Id, departmentid) => {
        navigate(`/doctor-profile/${departmentid}/${Id}`);
        sessionStorage.setItem("Docprofile", JSON.stringify({ title, path: "/", pagename: "Home" }));
    }

    const HandleNavigateLab = (item, category, type) => {
        if (type === "Lab") {
            navigate("/packages");
            sessionStorage.setItem("Docprofile", JSON.stringify({ Categoryid: category, Labid: item.id, title: "Home", path: "/" }));
        } else {
            navigate("/store-home");
            sessionStorage.setItem("Docdetails", JSON.stringify({ Docid: item.id, Categoreyid: item.department_id }));
        }
    }

    const OneSignalHandle = (AppId) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid && !initialized.current) {
            OneSignal.init({
                appId: AppId,
                safari_web_id: "web.onesignal.auto.xxx",
                notifyButton: {
                    enable: true,
                },
                serviceWorkerParam: { scope: "/" },
                serviceWorkerPath: "OneSignalSDKWorker.js",
                allowLocalhostAsSecureOrigin: true,
            }).then(() => {

                initialized.current = true;

                OneSignal.User.addTags({
                    "user_id": Userid,
                });
            })
                .catch((error) => {
                    // console.error("OneSignal :-->>", error);
                });
        }
    }

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [loading]);

    const HandleAddPatient = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            setIsPatient(true);
            setPatientData("");
        } else {
            setIsLoginShow(true);
        }
    }

    useEffect(() => {
        if (!paymentStatus) return;

        if (paymentStatus === "PaymentFaild") {
            showToast({ title: "Payment Closed !!", id: "info" });
            setPaymentStatus("");
        }
    }, [paymentStatus]);

    const HandleLocationEnable = () => {
        setLocationError(false);
        secureLocalStorage.setItem("location", true);
        HomeRef.current = false;
        fetchHomeData(21.215814, 72.828308);

    }

    const HandleNotificationEnable = () => {
        setNotificationError(false);
        secureLocalStorage.setItem("notification", true);
    }

    const handleNavigateCat = (path) => {
        navigate(path);
    }

    return (
        <div className="dashboard">
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div>
                    <div className="width-container">

                        <div className="flex items-center justify-start md:justify-center gap-4 md:gap-8 overflow-x-auto pt-10 mb-10">
                            {CategoryList.map((item, index) => {
                                return <motion.div key={index} onClick={() => handleNavigateCat(item.href, item.label)}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3, delay: index * 0.05 }}
                                    whileHover={{ scale: 1.05, y: -2 }}
                                    className="flex flex-col items-center gap-2 min-w-[100px] group cursor-pointer" >
                                    <div className="relative">
                                        <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-30 blur-xl transition-opacity rounded-full`} />
                                        <div className={`relative w-16 h-16 rounded-full p-[2px] bg-gradient-to-br ${item.gradient} shadow-md group-hover:shadow-lg transition-all`}>
                                            <div className="w-full h-full bg-white rounded-full flex items-center justify-center">
                                                <div className="w-7 h-7 transition-all ${item.color.replace('text-', 'text-')}/60 group-hover:${item.color} group-hover:scale-110">
                                                    {item.icon}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span className={`text-[13px] text-center font-medium transition-colors ${item.active
                                        ? item.color
                                        : `text-gray-600 group-hover:font-semibold`
                                        }`}>
                                        {item.label}
                                    </span>
                                    {item.active && (
                                        <motion.div
                                            className={`h-1 bg-gradient-to-r ${item.gradient} rounded-full`}
                                            animate={{ width: ['32px', '40px', '32px'] }}
                                            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
                                        />
                                    )}
                                </motion.div>
                            })}
                        </div>

                        <Banner images={sliderImg} />

                        <div className="patient">
                            <h1 className='title mb-[10px]'>{t("My Patient")}</h1>
                            <div className="slider-container mt-[10px]">
                                <Slider {...Patientsetting}>
                                    <div onClick={HandleAddPatient} className="h-[180px] border border-blue-200 bg-blue-100/70 text-center rounded-[15px] cursor-pointer hover:shadow-lg my-2">
                                        <div className="h-full flex flex-col justify-center items-center gap-2 p-[10px]">
                                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full">
                                                <FiPlus className='text-[--button-color] text-[20px]' />
                                            </div>
                                            <h1 className='text-[--button-color] font-medium'>{t("Add New Patient")}</h1>
                                        </div>
                                    </div>
                                    {familyMemberList.map((item, index) => {
                                        return <div onClick={() => HandleGetPatientDetails(item.id)} key={index} className=" h-[180px] bg-white border text-center rounded-[15px] cursor-pointer hover:shadow-lg transition-all shadow-sm my-2">
                                            <div className="h-full flex flex-col justify-center items-center gap-2 p-[10px]">
                                                <div className="w-[70px] h-[70px] bg-white flex items-center justify-center rounded-full overflow-hidden">
                                                    <ImageLoad src={ImgBaseUrl + item.profile_image} CustomeStyle={"w-full h-full object-cover"} alt={"logo"} />
                                                </div>
                                                <div className="">
                                                    <h1 className='font-medium'>{item.name}</h1>
                                                    <p class="text-text-secondary text-[14px]">{item.reletion_name}</p>
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>

                        {favoritList.length >= 1 && <div className="favorite my-[25px]">
                            <h1 className='title mb-[10px]'>{t("Your favorites")}</h1>
                            <h1 className='font-[500] -mt-[10px]'>{t("Doctor your Love")} 💙</h1>
                            <div className="slider-container mt-[20px]">
                                <Slider {...Patientsetting}>
                                    {favoritList.map((item, index) => {
                                        return <div onClick={() => HandleNavigateDoc("Doctor Profile", item.id, item.department_id)} key={index} className="add_box cursor-pointer">
                                            <div className="add">
                                                <ImageLoad src={ImgBaseUrl + item.logo} CustomeStyle={"w-[100%] h-[100%] object-cover"} alt={"logo"} />
                                            </div>
                                            <h1 className='text-[16px] mt-[10px]'>{item.title}</h1>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>}

                        <div className="dynamic_list">
                            {dynamicList.map((item, index) => {
                                if (item.module === "Hospital") {
                                    return <div key={index} className="my-[25px]">
                                        <h1 className='title'>{item.title}</h1>
                                        <div className="slider-container mt-[20px]">
                                            <Slider {...boxsetting}>
                                                {item.details.map((item, index) => {
                                                    return <div key={index} onClick={() => HandleNavigateDoc(item.name, item.id, item.department_id)} className="hospital_box">
                                                        <div className="relative">
                                                            <ImageLoad src={ImgBaseUrl + item.logo} CustomeStyle={"w-[100%] h-[230px] object-cover"} alt={"logo"} />
                                                            <div className="absolute top-[5px] left-[5px] rating_blur">
                                                                <h1 className='flex items-center text-white gap-[5px] font-[500]'><FaStar className='text-orange-400 text-[17px]' />{item.avg_star}</h1>
                                                            </div>
                                                        </div>
                                                        <div className="p-[10px] w-[100%]">
                                                            <h1 className='font-[500] text-[20px] whitespace-nowrap overflow-ellipsis overflow-hidden'>{item.name}</h1>
                                                            <div className="flex items-center gap-[5px] border-b pb-2">
                                                                <svg width="18" height="18" className='min-w-[18px]' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="gray" />
                                                                </svg>
                                                                <p className='leading-5 text-[14px] line-clamp-1'>{item.address}</p>
                                                            </div>
                                                            <div className="pt-2">
                                                                <p className='text-gray-600'>Consultation Fees</p>
                                                                <span className='font-bold text-[18px] text-[--button-color]'>{currency + item.client_visit_price}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                } else if (item.module === "Lab" || item.module === "Store") {
                                    return <div key={index} className="my-[25px]">
                                        <h1 className='title'>{item.title}</h1>
                                        <div className="slider-container mt-[20px]">
                                            <Slider {...labsetting}>
                                                {item.details.map((Item, index) => {
                                                    return <div key={index} onClick={() => HandleNavigateLab(Item, item.category, item.module)} className="border-[1px] rounded-[10px] p-[10px] cursor-pointer">
                                                        <div className="flex items-center gap-[10px]">
                                                            <ImageLoad src={ImgBaseUrl + Item.logo} CustomeStyle={"max-w-[80px] min-w-[80px] h-[90px] object-cover rounded-[10px]"} alt={"logo"} />
                                                            <div className="overflow-hidden w-full">
                                                                <h1 className='font-[500] text-[18px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{Item.name}</h1>
                                                                <p className='text-[14px] text-gray-600 whitespace-nowrap overflow-hidden overflow-ellipsis'>{Item.address}</p>
                                                                <div className="flex items-center gap-[10px] justify-between">
                                                                    <h1 className='flex items-center gap-[5px] font-[500]'><FaStar className='text-orange-400 text-[17px]' />{Item.avg_star} <span className='text-gray-500'>({Item.tot_review})</span> </h1>
                                                                    <h1 className='flex items-center gap-[5px] font-[500]'>
                                                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http:www.w3.org/2000/svg">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="black" />
                                                                        </svg>
                                                                        {Item.distance} KM
                                                                    </h1>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                } else {
                                    return <div key={index} className="my-[25px]">
                                        <h1 className='title'>{item.title}</h1>
                                        <div className="slider-container mt-[20px]">
                                            <Slider {...boxsetting}>
                                                {item.details.map((item, index) => {
                                                    return <div key={index} onClick={() => HandleNavigateDoc(item.name, item.id, item.department_id)} className="doctor_box p-[15px]">
                                                        <div className="relative">
                                                            <ImageLoad src={ImgBaseUrl + item.logo} CustomeStyle={"w-[100%] h-[230px] object-cover rounded-[10px]"} alt={"logo"} />
                                                            <div className="absolute top-[5px] left-[5px] rating_blur">
                                                                <h1 className='flex items-center text-white gap-[5px] font-[500]'><FaStar className='text-orange-400 text-[17px]' />{item.avg_star}</h1>
                                                            </div>
                                                        </div>
                                                        <div className="pt-[8px]">
                                                            <div className="leading-5">
                                                                <h1 className='font-[500] text-[20px] whitespace-nowrap overflow-ellipsis overflow-hidden'>{item.name}</h1>
                                                                <span className='text-gray-600 text-[14px]'>{item.title}</span>
                                                            </div>
                                                            <div className="flex items-center gap-[5px] border-b pt-[8px] pb-[10px]">
                                                                <svg width="18" height="18" className='min-w-[18px]' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="gray" />
                                                                </svg>
                                                                <p className='leading-5 text-[14px] line-clamp-1'>{item.address}</p>
                                                            </div>

                                                            <button className='w-full text-[15px] text-[--button-color] mt-[15px] font-medium flex items-center justify-center gap-2 opacity-75 hover:opacity-100'>
                                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M16.5521 21.752C16.0931 21.752 15.6311 21.69 15.1751 21.565C9.01011 19.873 4.12909 14.995 2.43609 8.83402C2.05109 7.43302 2.26204 5.97301 3.03204 4.72501C3.80504 3.47101 5.0761 2.58601 6.5191 2.29801C7.4791 2.10601 8.4281 2.53401 8.9151 3.35501L10.4781 5.995C11.2371 7.277 10.86 8.928 9.61896 9.754L8.4881 10.506C9.5451 12.676 11.3229 14.459 13.4839 15.515L14.2462 14.378C15.0772 13.139 16.7281 12.768 18.0091 13.531L20.6522 15.107C21.4702 15.595 21.8931 16.55 21.7071 17.482C21.4191 18.925 20.5341 20.196 19.2811 20.969C18.4391 21.487 17.5021 21.752 16.5521 21.752ZM6.97809 3.75C6.92909 3.75 6.87911 3.75502 6.83111 3.76502C5.77711 3.97602 4.86412 4.611 4.31012 5.512C3.76112 6.402 3.61009 7.44101 3.88409 8.43601C5.43709 14.089 9.91608 18.566 15.5721 20.118C16.5681 20.391 17.604 20.239 18.493 19.691C19.393 19.136 20.0291 18.222 20.2361 17.186C20.2981 16.875 20.1571 16.556 19.8831 16.393L17.241 14.817C16.646 14.463 15.878 14.636 15.492 15.211L14.377 16.876C14.177 17.174 13.7911 17.288 13.4651 17.15C10.5021 15.911 8.09113 13.495 6.85113 10.521C6.71313 10.189 6.82899 9.807 7.12799 9.608L8.78912 8.50299C9.36512 8.11999 9.54007 7.353 9.18707 6.758L7.62408 4.11899C7.48708 3.88699 7.23909 3.75 6.97809 3.75Z" fill="currentColor" />
                                                                </svg>
                                                                {t("Book Today")}
                                                            </button>

                                                        </div>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                }
                            })}
                        </div>

                    </div>
                </div>}

            {isBooking && <div className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                <div className="bottme-box">
                    <BookingDetails Data={bookingData} />
                </div>
            </div>}

            {isPatient && <div onClick={() => setIsPatient(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]'>
                <div onClick={(e) => e.stopPropagation()} className="add-patient">
                    <AddPatient Relation={relationshipData} BooldType={booldData} Data={patientData} />
                </div>
            </div>}

            {deviceCheck && <div onClick={() => setDeviceCheck(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-[15px] p-4">
                    <h6 className='m-0 font-[500] text-[18px] text-gray-600'>{t("Required for voice and video calls. Make")} <br /> {t("sure your audio device (headset, speakers,")} <br /> {t("or microphone) is connected and working.")}</h6>
                </div>
            </div>}

            {locationError && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center">{t('Enable Location Services')}</h2>
                            <img src={LocationImg} alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("To provide accurate services, please enable your location.")}</h6>
                                </div>
                                <div className="flex gap-[5px]">
                                    <span className="text-[18px]">2.</span>
                                    <h6> {t("Allow location access when prompted. If not prompted, enable it in your browser settings.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleLocationEnable} className="bg-[#4038FF] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Enable Now")}</button>
                            <button onClick={HandleLocationEnable} className="border-[1px] border-[#4038FF] text-[#4038FF] w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Default")}</button>
                        </div>
                    </div>
                </div>
            )}

            {notificationerror && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center font-bold">{t("Enable Smart Alerts")}</h2>
                            <img src={NotificationImg} className='w-[100%] rounded-[10px]' alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("Let us notify you about upcoming bookings, changes, and key updates directly through your browser.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleNotificationEnable} className="bg-[#4038FF] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Enable Now")}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Dashboard;
/* jshint ignore:end */